import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          padding: '0px',
          fontFamily: 'Poppins',
        },
      },
    }
  },
});

export default theme
